import { render } from "./BackToList.vue?vue&type=template&id=043d4e37"
import script from "./BackToList.vue?vue&type=script&lang=js"
export * from "./BackToList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__